import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { DeleteIcon, ExpandIcon } from '../../../../bombiix-icon';
import { NewInput } from '../../../../Components/PIM/common/NewInput';
import { NewCheckbox } from '../../../../Components/PIM/common/NewCheckbox';

const style = {
  cursor: 'move',
};
function RenderLabelOption({ column, index, moveCard, id, removeLabel, handleChange, wholeArry }) {
  const ref = useRef(null);
  const { t } = useTranslation('common');
  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.5 : 1;
  drag(drop(ref));

  return (
    <div className="mb-2 form-group d-flex w-100" key={id} style={{ ...style, opacity }} data-handler-id={handlerId} ref={ref}>
      <div className="colour-text-container">
        <div className="checkbox-content">
          <div className="checkbox-label no-label margin-auto">
            <NewCheckbox onChange={(e) => { handleChange(e.target.checked, index, 'isLabelColourChecked'); }} name={`labelColoursOptions${index}`} id={`labelColoursOptions${index}`} checked={column?.isLabelColourChecked} value={column?.isLabelColourChecked} />
            <label htmlFor={`labelColoursOptions${index}`} className="chklabel" />
          </div>
        </div>
        <div className="color-content">
          <NewInput
            type="color"
            id="labelColourStyle"
            className="p-0"
            value={column?.colourHexCode}
            onChange={(e) => handleChange(e.target.value, index, 'colourHexCode')}
          />
          <label htmlFor="labelColourStyle" />
        </div>
        <input
          type="text"
          className="text-content fs-custom-module"
          value={column?.colourName}
          placeholder={t('CUSTOM_MODULES.LIBRARY.RENDER_LABEL.ADD_COLOUR_NAME')}
          onChange={(e) => handleChange(e.target.value, index, 'colourName')}
        />
      </div>

      <button type="button" className="btn btn-outline m-0 ml-2" id={column?.colourName}>
        <ExpandIcon size={24} />
      </button>
      {wholeArry.length > 1 && (
        <button type="button" className="btn btn-outline m-0 ml-2" onClick={() => removeLabel(index)}>
          <DeleteIcon size={24} />
        </button>
      )}
    </div>
  );
}

export default RenderLabelOption;
